import DOMPurify from 'dompurify';

import { dateFormatter } from '@dreryk/react-common';

import {
   StyledNewsCardListElementDateAndTag,
   StyledNewsCardListElementLink,
} from './NewsCardListElementContent.styled';
import { EGabinetNews, EGabinetNewsTag } from './NewsCard.hooks';

type NewsCardListElementContentProps = {
   egabinetNews: EGabinetNews;
   newsCardListElementTag?: EGabinetNewsTag;
};

export const NewsCardListElementContent = (props: NewsCardListElementContentProps): JSX.Element => {
   return (
      <>
         <StyledNewsCardListElementLink href={props.egabinetNews.link} target='_blank' rel='noopener'>
            {/* eslint-disable-next-line react/no-danger */}
            <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.egabinetNews.title) }} />
         </StyledNewsCardListElementLink>
         <StyledNewsCardListElementDateAndTag>
            {dateFormatter(props.egabinetNews.date)}
            {props.newsCardListElementTag ? (
               <>
                  {' • '}
                  {/* eslint-disable-next-line react/no-danger */}
                  <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.newsCardListElementTag) }} />
               </>
            ) : null}
         </StyledNewsCardListElementDateAndTag>
      </>
   );
};
